import React from 'react';
import { Link } from 'react-router-dom';
import portfolioService from '../../services/portfolioService';
import './PortfolioCard.css';

const PortfolioCard = ({ portfolio, onDelete }) => {
  const stats = portfolio.stats || {};
  const budgetUtilization = stats.budget_utilization || 0;
  const overallHealth = stats.overall_health || 'On Track';
  const healthColor = portfolioService.getHealthColor(overallHealth);
  const statusColor = portfolioService.getStatusColor(portfolio.status);
  const budgetStatusColor = portfolioService.getBudgetStatusColor(budgetUtilization);

  const handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onDelete(portfolio.id);
  };

  return (
    <div className="portfolio-card">
      <div className="portfolio-card-header">
        <div className="portfolio-title-section">
          <p className="portfolio-name">
            {portfolio.name}
          </p>
          {portfolio.code && (
            <span className="portfolio-code">{portfolio.code}</span>
          )}
        </div>
        <div className="portfolio-actions">
          <Link 
            to={`/app/portfolios/${portfolio.id}/edit`} 
            className="action-btn edit-btn custom-icon-btn"
            title="Edit"
          >
            <i className="fas fa-edit"></i>
          </Link>
          <button 
            onClick={handleDelete} 
            className="action-btn delete-btn custom-icon-btn"
            title="Delete"
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      </div>

      <div className="portfolio-card-body">
        {portfolio.description && (
          <p className="portfolio-description">{portfolio.description}</p>
        )}

        <div className="portfolio-meta">
          <div className="meta-item">
            <span 
              className="status-badge" 
              style={{ backgroundColor: statusColor }}
            >
              {portfolio.status}
            </span>
          </div>
          
          {portfolio.owner && (
            <div className="meta-item">
              <i className="fas fa-user"></i>
              <span>{portfolio.owner.first_name} {portfolio.owner.last_name}</span>
            </div>
          )}

          <div className="meta-item">
            <i className="fas fa-calendar"></i>
            <span>{portfolioService.formatDateRange(portfolio.start_date, portfolio.end_date)}</span>
          </div>
        </div>

        <div className="portfolio-stats-grid">
          <div className="stat-item">
            <div className="stat-icon custon-edit-icon" style={{ color: '#fff' }}>
              <i className="fas fa-project-diagram"></i>
            </div>
            <div className="stat-details">
              <div className="stat-value custom-state-value">{stats.total_projects || 0}</div>
              <div className="stat-label">Projects</div>
            </div>
          </div>

          <div className="stat-item">
            <div className="stat-icon" style={{ color: healthColor }}>
              <i className="fas fa-heartbeat"></i>
            </div>
            <div className="stat-details">
              <div className="stat-value custom-state-value">{overallHealth}</div>
              <div className="stat-label">Health</div>
            </div>
          </div>

          <div className="stat-item">
            <div className="stat-icon" style={{ color: '#f57c00' }}>
              <i className="fas fa-dollar-sign"></i>
            </div>
            <div className="stat-details">
              <div className="stat-value custom-state-value">
                {portfolioService.formatBudget(portfolio.budget_allocated)}
              </div>
              <div className="stat-label">Budget</div>
            </div>
          </div>

          <div className="stat-item">
            <div className="stat-icon" style={{ color: budgetStatusColor }}>
              <i className="fas fa-chart-pie"></i>
            </div>
            <div className="stat-details">
              <div className="stat-value custom-state-value">{budgetUtilization.toFixed(1)}%</div>
              <div className="stat-label">Utilized</div>
            </div>
          </div>
        </div>

        {portfolio.budget_allocated > 0 && (
          <div className="budget-bar-container">
            <div className="budget-bar">
              <div 
                className="budget-fill"
                style={{ 
                  width: `${Math.min(budgetUtilization, 100)}%`,
                  backgroundColor: budgetStatusColor
                }}
              />
            </div>
            <div className="budget-info">
              <span>
                {portfolioService.formatBudget(stats.budget_spent || 0)} spent
              </span>
              <span>
                {portfolioService.formatBudget(stats.budget_remaining || 0)} remaining
              </span>
            </div>
          </div>
        )}

        {!portfolio.is_active && (
          <div className="inactive-badge">
            <i className="fas fa-pause-circle"></i> Inactive
          </div>
        )}
      </div>

      {/* <div className="portfolio-card-footer">
        <Link to={`/app/portfolios/${portfolio.id}`} className="view-details-btn">
          View Details <i className="fas fa-arrow-right"></i>
        </Link>
      </div> */}
    </div>
  );
};

export default PortfolioCard;

